import { useInfiniteQuery } from '@tanstack/react-query';
import type {
  FetchTimelineParams,
  FetchTimelineResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchCareTimeline } from '../api/fetchCareTimeline.js';
import { careTimelineKeys } from './keys.js';

type StableTimelineParams = Pick<FetchTimelineParams, 'limit'>;

export function careTimelineInfiniteQueryDefinition(userId: string, params?: StableTimelineParams) {
  const stable: StableTimelineParams = { limit: params?.limit };

  return {
    queryKey: careTimelineKeys.timeline(userId, stable),
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam, signal }: { pageParam?: string; signal?: AbortSignal }) =>
      fetchCareTimeline(
        userId,
        {
          limit: stable.limit,
          before_cursor: pageParam ?? null,
        },
        signal
      ),
    getNextPageParam: (lastPage: FetchTimelineResponseT) => lastPage.beforeCursor ?? undefined,
    enabled: userId.trim() !== '',
  } as const;
}

export function useCareTimelineInfiniteQuery(
  userId: string | undefined,
  params?: StableTimelineParams
) {
  return useInfiniteQuery({
    ...careTimelineInfiniteQueryDefinition(userId ?? '', params),
    enabled: !!userId && userId.trim() !== '',
  });
}
